import { render, staticRenderFns } from "./upload-table.vue?vue&type=template&id=a54b8f4c&scoped=true&"
import script from "./upload-table.vue?vue&type=script&lang=js&"
export * from "./upload-table.vue?vue&type=script&lang=js&"
import style0 from "./upload-table.vue?vue&type=style&index=0&id=a54b8f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54b8f4c",
  null
  
)

export default component.exports